import { useMemo } from 'react';
import COOKIES from '~/constants/cookies';
import BrowserCookies from '~/utilities/BrowserCookies';
import { loadItemFromLocalStorage } from '~/utilities/localStorage';
import { localStorageKey } from '../constants';

const sevenDays = 1000 * 60 * 60 * 24 * 7;

export default function useHasSeenNudgeRecently() {
  const storage =
    loadItemFromLocalStorage<Record<string, string>>(localStorageKey);

  return useMemo(() => {
    const bcid = BrowserCookies.get(COOKIES.browserCookieId);
    const lastSeen = bcid && storage ? storage[bcid] : null;

    return lastSeen
      ? new Date(lastSeen).getTime() > Date.now() - sevenDays
      : false;
  }, [storage]);
}
